<script context="module">
 export const typeValues = ['pic', 'text'];
</script>

<script>
	export let type = typeValues[0];
</script>

<style>
	.pic {
		display: block;
		border-radius: 5px;
		margin: 0.5rem auto;
		max-width: 100%;
	}
</style>

{#if type === 'pic'}
<img height="360" class="pic" src="https://picsum.photos/500" alt="lorem picsum placeholder" />
{:else if type === 'text'}
<p>
 Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque lobortis pellentesque convallis. Suspendisse varius libero eget congue sollicitudin. Praesent mollis sollicitudin enim ac porttitor. Maecenas venenatis accumsan risus in luctus. Fusce feugiat urna in mauris egestas, viverra posuere tellus feugiat. Pellentesque velit elit, tincidunt id porttitor nec, iaculis quis ante. Morbi vitae cursus metus. Ut volutpat tellus at lacus sollicitudin aliquet. Sed ut felis ac ligula facilisis euismod in sed neque. Morbi eu porta tortor. Maecenas ultrices, magna sit amet mollis faucibus, est massa blandit metus, maximus consectetur dui eros nec lacus. Cras sagittis tristique urna et venenatis. Duis tempus tellus vel feugiat ullamcorper. Nam malesuada pharetra tellus imperdiet hendrerit. Ut venenatis ex nec risus sagittis, ac lacinia ex commodo. Suspendisse sagittis ornare nunc non vestibulum.

Proin dictum faucibus ex at ornare. Duis eu purus justo. Donec lobortis, velit nec sagittis accumsan, dui metus sollicitudin nunc, ac pretium leo enim at magna. Aenean eleifend lacus vel congue scelerisque. Sed mattis nec nibh eget laoreet. Vivamus semper sed enim eget tincidunt. Mauris eu finibus metus. Donec non consequat metus, id rhoncus augue. Quisque eget nisi quis sapien ultricies hendrerit. Duis suscipit elementum porta. Praesent sed tortor a leo pharetra eleifend. Mauris non ornare erat. Nulla eleifend dignissim odio. Mauris tempor feugiat tortor at tincidunt.

Nam nec erat sem. In finibus malesuada arcu sed facilisis. Vestibulum velit ipsum, lacinia ut blandit eu, ornare eget metus. Praesent nulla quam, pretium non nisl a, gravida posuere quam. Nam vestibulum orci nec efficitur facilisis. In hac habitasse platea dictumst. Vestibulum scelerisque augue enim, nec egestas velit interdum sed.
</p>
{/if}